// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__le+j6","copyright":"Footer_copyright__w775S","divisor":"Footer_divisor__suDlo","link":"Footer_link__BpqA7"};